import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// ✅ Pages & Components
import ScrollToTopButton from "./components/ScrollToTopButton";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import Contact from "./pages/Contact";

import CaseStudyDetails from "./components/CaseStudyDetails";
import CustomNavbar from './components/CustomNavbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServicesSection from './components/ServicesSection';
import WorkSection from './components/WorkSection';
import Footer from './components/Footer';
import PartnersSection from './components/PartnersSection';
import BlogSection from './components/BlogSection';
import LeaderNeedsSection from './components/LeaderNeedsSection';

// ✅ Pages
import About from './pages/About';
import Service from './pages/Service';
import Blog from './pages/Blog';
import Terms from "./pages/Terms"; 
import Privacy from './pages/Privacy';

import DigitalRoadmap from './components/DigitalRoadmap';
import FounderSection from './components/FounderSection';
import CaseStudiesSection from './components/CaseStudiesSection';



 // import new page

function App() {
  return (
    <Router>
      <ScrollToTopButton />
      <Routes>
        {/* ✅ Homepage Route */}
        <Route
          path="/"
          element={
            <>
              <CustomNavbar />
              <HeroSection />
              <FeaturesSection />
              <AboutSection />
             <CaseStudiesSection/>
           
              <WhyChooseUs />
              <DigitalRoadmap/>
              
              
              <LeaderNeedsSection />
             <ServicesSection />
              <BlogSection/>
              <FounderSection/>
              <WorkSection />
              <PartnersSection />
              <Footer />
            </>
          }
        />

        {/* ✅ About Page Route */}
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
         <Route path="/blog" element={<Blog />} /> 
         <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy
          />} />
            <Route path="/" element={<CaseStudiesSection />} />
        <Route path="/case-study/:id" element={<CaseStudyDetails />} />
      </Routes>
    </Router>
  );
}

export default App;
